import { cleanObject } from '@shared/utils';
import getPieveCompanyIdForRequest from '@/lib/auth/getPieveCompanyIdForRequest.js';
import { get, post, put } from '@/redux/requests/api.js';

export const listSchedules = ({ limit = 200, offset = 0, q = null, active = null, includeArchived = null, includeTotal = true, sortBy = 'updatedAt', sortDirection = 'desc' } = {}, callback) => {
  const companyId = String(getPieveCompanyIdForRequest() || '').trim() || null;

  return get('/v1/pieve/schedules', {
    action: 'GET_SCHEDULES',
    loader: 'getSchedules',
    callback,
    meta: {
      companyId
    },
    query: cleanObject(
      {
        limit,
        offset,
        q,
        active,
        includeArchived,
        includeTotal,
        sortBy,
        sortDirection
      },
      { strict: true }
    )
  });
};

export const updateSchedule = ({ scheduleId, title, prompt, active, threadId, scheduleConfig, timezone, composerModel, composerReasoningEffort, expectedUpdatedAt = undefined, allowStaleWrite = undefined } = {}, callback) => {
  const normalizedScheduleId = String(scheduleId || '').trim();

  return put(`/v1/pieve/schedules/${encodeURIComponent(normalizedScheduleId)}`, {
    action: 'UPDATE_SCHEDULE',
    loader: 'updateSchedule',
    callback,
    data: cleanObject(
      {
        title,
        prompt,
        active,
        threadId,
        scheduleConfig,
        timezone,
        composerModel,
        composerReasoningEffort,
        expectedUpdatedAt,
        allowStaleWrite
      },
      { strict: true }
    )
  });
};

export const runSchedule = ({ scheduleId } = {}, callback) => {
  const normalizedScheduleId = String(scheduleId || '').trim();

  return post(`/v1/pieve/schedules/${encodeURIComponent(normalizedScheduleId)}/run`, {
    action: 'RUN_SCHEDULE',
    loader: 'runSchedule',
    eventKey: 'scheduleRun',
    callback,
    data: {}
  });
};

export const getScheduleRunList = ({ scheduleId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedScheduleId = String(scheduleId || '').trim();

  return get(`/v1/pieve/schedules/${encodeURIComponent(normalizedScheduleId)}/runs`, {
    action: 'GET_SCHEDULE_RUN_LIST',
    loader: 'getScheduleRunList',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getScheduleRunDailyCounts = ({ scheduleId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedScheduleId = String(scheduleId || '').trim();

  return get(`/v1/pieve/schedules/${encodeURIComponent(normalizedScheduleId)}/runs/daily-counts`, {
    action: 'GET_SCHEDULE_RUN_DAILY_COUNTS',
    loader: 'getScheduleRunDailyCounts',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getScheduleOperations = ({ scheduleId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedScheduleId = String(scheduleId || '').trim();

  return get(`/v1/pieve/schedules/${encodeURIComponent(normalizedScheduleId)}/operations`, {
    action: 'GET_SCHEDULE_OPERATIONS',
    loader: 'getScheduleOperations',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};

export const getScheduleRecentActivityChartDailyCounts = ({ scheduleId, startDate = undefined, endDate = undefined, timezone = undefined } = {}, callback) => {
  const normalizedScheduleId = String(scheduleId || '').trim();

  return get(`/v1/pieve/schedules/${encodeURIComponent(normalizedScheduleId)}/operations/daily-counts`, {
    action: 'GET_SCHEDULE_RECENT_ACTIVITY_CHART_DAILY_COUNTS',
    loader: 'getScheduleRecentActivityChartDailyCounts',
    callback,
    query: cleanObject(
      {
        startDate,
        endDate,
        timezone
      },
      { strict: true }
    )
  });
};
